export default function WatchDistributionChart({ data = [] }) {
  const max = Math.max(1, ...data.map((bucket) => bucket.count || 0));

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="text-lg font-semibold text-slate-950">Watch-time distribution</h2>
      <p className="text-sm text-slate-500">Share of stream duration watched by each watch session.</p>
      <div className="mt-5 space-y-4">
        {data.map((bucket) => (
          <div key={bucket.label} className="grid grid-cols-[5rem_1fr_3rem] items-center gap-3">
            <span className="text-sm font-medium text-slate-700">{bucket.label}</span>
            <div className="h-4 rounded-full bg-slate-100"><div className="h-4 rounded-full bg-[#FF3A20]" style={{ width: `${((bucket.count || 0) / max) * 100}%` }} /></div>
            <span className="text-right font-mono text-sm text-slate-700">{bucket.count || 0}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
